import { snakeCase } from 'lodash';
import React, { createContext, FC, useContext } from 'react';
import { TranslationKey, useTranslation } from 'hooks/use-translation';

export enum NotificationUserType {
  Vendor,
  Customer,
}

interface NotificationContext {
  isCustomerPortal?: boolean;
}

export const useEventTypeMessage = (key: string, options = {}): string =>
  useTranslation(
    `notifications.configuration.event_types.${snakeCase(
      key,
    )}` as TranslationKey,
    {
      ...options,
    },
  );

export const useTitle = (key: string, options = {}): string =>
  useTranslation(
    `notifications.configuration.groups.${snakeCase(key)}` as TranslationKey,
    {
      ...options,
    },
  );

export const useChannelHeader = (key: string): string =>
  useTranslation(
    `notifications.configuration.channels.${snakeCase(key)}` as TranslationKey,
  );

const NotificationContext = createContext<NotificationContext>({
  isCustomerPortal: false,
});

export const NotificationContextProvider: FC<NotificationContext> = ({
  children,
  isCustomerPortal,
}) => {
  return (
    <NotificationContext.Provider value={{ isCustomerPortal }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => {
  const notificationContext = useContext(NotificationContext);

  if (!notificationContext) {
    throw new Error('Notification context not available');
  }

  return notificationContext;
};
